import { format } from "date-fns";
import Mousetrap from "mousetrap";
import { useEffect, useState } from "react";
import {
  DataGrid,
  Icon,
  IconButton,
  ListStatusVencimento,
  PermissionDialog,
  SelecaoTitulosFiltro,
  Tooltip,
} from "../../../components";
import { useImportContext } from "../../../contexts/import.context";
import {
  filtrosUrl,
  PermisoesHelper,
  selecaoTitulosLote,
  value,
} from "../../../helpers";
import { ListLayout } from "../../../layouts";
import {
  BancosCaixasService,
  ColaboradorService,
  CondicoesPagamentoService,
  ConfiguracoesService,
  ContasReceberService,
  history,
  MeioPagamentoService,
  notification,
  PessoaService,
  SessionService,
  UsuarioService,
} from "../../../services";
import { formatDate, formatPrice, responseErros } from "../../../utils";
import {
  BaixaLoteReceber,
  ButtonMenu,
  CarnePagamentoDialog,
  CompensacaoDialog,
  FiltroCustom,
  FormFiltroAvancado,
  RenegociacaoTitulos,
} from "./components";
import {
  calculaJurosBaixa,
  calculaMultaBaixa,
  calculaMultaJurosBaixa,
  calculaTotalAReceber,
  jurosMultaDoTitulo,
} from "./list-contas-receber";
import { HistoricoPagamentos } from "../add-contas-receber/components";
import {
  addIdUsuario,
  getAtrasoDias,
} from "../add-contas-receber/add-contas-receber";
import { usePermissaoRetirarBaixa } from "../../../components/permission-dialog/use-permissao-retirar-baixa";

const ListContasReceber = () => {
  const { initialCollapses } = useImportContext();

  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("contas-receber-visualizar");
  const { setContaReceberDto } = useImportContext();
  const [loading, setLoading] = useState(false);
  const [contasReceber, setContasReceber] = useState([]);
  const [listaPessoas, setListaPessoas] = useState([]);
  const [listaPessoasFiltro, setListaPessoasFiltro] = useState([]);
  const [pessoaFiltro, setPessoaFiltro] = useState(null);
  const [buscaFiltro, setBuscaFiltro] = useState("");
  const [baixaLote, setBaixaLote] = useState({});
  const [rowCount, setRowCount] = useState(null);
  const [renderBaixaLote, setRenderBaixaLote] = useState(false);
  const [renegociacaoTitulos, setRenegociacaoTitulos] = useState({});
  const [renderRenegociacaoTitulos, setRenderRenegociacaoTitulos] =
    useState(false);
  const [openCompensacao, setOpenCompensacao] = useState(false);
  const [linhasSelecionadas, setLinhasSelecionadas] = useState([]);
  const [openHistorico, setOpenHistorico] = useState(false);
  const [contaSelecionada, setContaSelecionada] = useState(null);
  const [contasReceberSelecionadas, setContasReceberSelecionadas] = useState(
    [],
  );
  const [ultimaBusca, setUltimaBusca] = useState({
    tipo: "simples",
    filtros: {},
  });
  const [contasFiltroSelecionadas, setContasFiltroSelecionadas] =
    useState(null);
  const [listaBancosCaixas, setListaBancosCaixas] = useState([]);
  const [listaCondicoesPagamento, setListaCondicoesPagamento] = useState([]);
  const [listaMeiosPagamento, setListaMeiosPagamento] = useState([]);
  const [filtrosDialog, setFiltrosDialog] = useState({});
  const [totalAReceber, setTotalAReceber] = useState({
    multa: 0,
    juros: 0,
    subtotal: 0,
    receber: 0,
  });
  const [jurosMultaEmpresas, setJurosMultaEmpresas] = useState([]);
  const [openCarnePagamento, setOpenCarnePagamento] = useState(false);
  const { dialogPermissao, confirmarExclusaoRenegociacao } =
    usePermissaoRetirarBaixa();
  const bancosCaixasService = new BancosCaixasService();
  const contasReceberService = new ContasReceberService();
  const pessoaService = new PessoaService();
  const configuracoesService = new ConfiguracoesService();
  const condicoesPagamentoService = new CondicoesPagamentoService();
  const meioPagamentoService = new MeioPagamentoService();
  const colaboradorService = new ColaboradorService();
  const usuarioService = new UsuarioService();
  const sessionService = new SessionService();
  const empresa = sessionService.getEmpresa();
  const usuario = sessionService.getUsuario();
  const status = [
    {
      nome: "ABERTO",
      label: "Aberto",
      cor: "#4FBB53",
    },
    {
      nome: "BAIXADO",
      label: "Baixado",
      cor: "#004780",
    },
    {
      nome: "BAIXADO_PARCIAL",
      label: "Baixado Parcial",
      cor: "#EA9D2B",
    },
    {
      nome: "CANCELADO",
      label: "Cancelado",
      cor: "#DC3545",
    },
  ];
  const buttonSelectOpcoes = [
    { permission: true, descricao: "Importação Excel" },
    { permission: true, descricao: "Nota de Crédito" },
    { permission: true, descricao: "Carnê de Pagamento" },
  ];
  if (empresa.moduloBoleto) {
    buttonSelectOpcoes.push({
      permission: permissoesHelper.temPermisao("boletos-visualizar"),
      descricao: "Boleto",
    });
  }
  const colunas = [
    {
      field: "status",
      headerName: "Status",
      flex: 100,
      renderCell: (params) => {
        switch (params.value) {
          case "BAIXADO":
            return (
              <Tooltip title="Baixado" arrow placement="right">
                <Icon>
                  <i
                    className="ph-fill ph-circle"
                    style={{ color: "#004780", fontSize: 18 }}
                  ></i>
                </Icon>
              </Tooltip>
            );
          case "BAIXADO_PARCIAL":
            return (
              <Tooltip title="Baixado Parcial" arrow placement="right">
                <Icon>
                  <i
                    className="ph-fill ph-circle"
                    style={{ color: "#EA9D2B", fontSize: 18 }}
                  ></i>
                </Icon>
              </Tooltip>
            );
          case "CANCELADO":
            return (
              <Tooltip title="Cancelado" arrow placement="right">
                <Icon>
                  <i
                    className="ph-fill ph-circle"
                    style={{ color: "#DC3545", fontSize: 18 }}
                  ></i>
                </Icon>
              </Tooltip>
            );
          default:
            return (
              <Tooltip title="Aberto" arrow placement="right">
                <Icon>
                  <i
                    className="ph-fill ph-circle"
                    style={{ color: "#4FBB53", fontSize: 18 }}
                  ></i>
                </Icon>
              </Tooltip>
            );
        }
      },
    },
    {
      field: "numeroTitulo",
      headerName: "Nº Título",
      flex: 200,
      filtrar: true,
    },
    {
      field: "empresaId",
      headerName: "Empresa",
      flex: 150,
      renderCell: (params) => {
        if (!usuario.acessosEmpresas?.length) return "";
        const empresa = value.autoComplete(
          usuario.acessosEmpresas,
          params.value,
        )?.fantasia;
        return (
          <Tooltip title={empresa} arrow placement="right">
            <span>{empresa.replace(/\s+/g, "").slice(0, 3).toUpperCase()}</span>
          </Tooltip>
        );
      },
    },
    {
      field: "tipo",
      headerName: "Tipo",
      flex: 200,
      valueGetter: (params) =>
        params.value == "TITULO_NORMAL" ? "Título normal" : "Nota de crédito",
    },
    {
      field: "pagadorId",
      headerName: "Cliente",
      flex: 400,
      sortable: false,
      filtroPessoa: true,
      valueGetter: (params) =>
        listaPessoas.find((item) => item.id == params.value)?.nomeRazaoSocial,
    },
    {
      field: "valor",
      headerName: "Valor",
      flex: 300,
      sortable: false,
      align: "right",
      headerAlign: "right",
      valueGetter: (params) => formatPrice(params.value),
    },
    {
      field: "saldoReceber",
      headerName: "Saldo a Receber",
      flex: 300,
      sortable: false,
      align: "right",
      headerAlign: "right",
      valueGetter: (params) =>
        params.value > 0 && params.row.status !== "CANCELADO"
          ? formatPrice(
              calculaMultaJurosBaixa(
                params.row,
                jurosMultaDoTitulo(jurosMultaEmpresas, params.row),
              ),
            )
          : "R$ 0,00",
    },
    {
      field: "dataVencimento",
      headerName: "Vencimento",
      flex: 250,
      align: "center",
      headerAlign: "center",
      valueGetter: (params) =>
        format(formatDate.received(params.value), "dd/MM/yyyy"),
    },
    {
      field: "acoes",
      headerName: "Ações",
      sortable: false,
      flex: 200,
      align: "center",
      headerAlign: "center",
      disableClickEventBubbling: true,
      hideable: false,
      renderCell: (params) => {
        return (
          <div>
            <IconButton
              onClick={async (event) => {
                event.stopPropagation();
                const conta = contasReceber.find(
                  (item) => item.id === params.id,
                );
                const listaIdUsuario = [];
                addIdUsuario(conta.pagamentos, listaIdUsuario);
                const usuarios = await buscaUsuarios(listaIdUsuario);
                setContaSelecionada({
                  ...conta,
                  pagamentos: conta.pagamentos.map((pagamento) => ({
                    ...pagamento,
                    insertUserName: usuarios.find(
                      ({ id }) => pagamento.insertUserId === id,
                    )?.nome,
                  })),
                });
                setOpenHistorico(true);
              }}
            >
              <Tooltip title="Histórico de Pagamentos" arrow placement="top">
                <i className="ph-bold ph-invoice" style={{ fontSize: 18 }}></i>
              </Tooltip>
            </IconButton>
            {permissoesHelper.temPermisao("contas-receber-editar") && (
              <IconButton
                onClick={() => {
                  initialCollapses();
                  onClickEditContaReceber(params.id);
                }}
              >
                <Tooltip title="Editar" arrow placement="top">
                  <i className="ph-fill ph-pencil" style={{ fontSize: 18 }}></i>
                </Tooltip>
              </IconButton>
            )}
            {permissoesHelper.temPermisao("contas-receber-excluir") && (
              <IconButton
                onClick={(event) => {
                  event.stopPropagation();
                  onClickDeleteContaReceber(params.id);
                }}
              >
                <Tooltip title="Excluir" arrow placement="top">
                  <i className="ph-fill ph-trash" style={{ fontSize: 18 }}></i>
                </Tooltip>
              </IconButton>
            )}
          </div>
        );
      },
    },
  ];

  const colunasMultaJuros = [
    {
      field: "multa",
      headerName: "Multa",
      flex: 250,
      sortable: false,
      align: "right",
      headerAlign: "right",
      valueGetter: (params) =>
        params.row.saldoReceber > 0 && params.row.status !== "CANCELADO"
          ? formatPrice(
              calculaMultaBaixa(
                params.row,
                jurosMultaDoTitulo(jurosMultaEmpresas, params.row),
              ),
            )
          : "R$ 0,00",
    },
    {
      field: "juros",
      headerName: "Juros",
      flex: 250,
      sortable: false,
      align: "right",
      headerAlign: "right",
      valueGetter: (params) =>
        params.row.saldoReceber > 0 && params.row.status !== "CANCELADO"
          ? formatPrice(
              calculaJurosBaixa(
                params.row,
                jurosMultaDoTitulo(jurosMultaEmpresas, params.row),
              ),
            )
          : "R$ 0,00",
    },
  ];

  const colunasListagem =
    ultimaBusca.filtros?.situacaoVencimento === "VENCIDAS"
      ? colunas.flatMap((coluna) =>
          coluna.field === "saldoReceber"
            ? [...colunasMultaJuros, coluna]
            : coluna,
        )
      : colunas;

  const dadosPagamentoColunas = [
    {
      field: "dataPagamento",
      headerName: "Data",
      flex: 400,
      valueGetter: (params) => {
        return format(formatDate.received(params.value), "dd/MM/yyyy");
      },
    },
    {
      field: "horaPagamento",
      headerName: "Hora",
      flex: 250,
      valueGetter: (params) => {
        return format(formatDate.received(params.row.dataPagamento), "HH:mm");
      },
    },
    {
      field: "bancoCaixaId",
      headerName: "Banco/Caixa",
      flex: 400,
      valueGetter: (params) => {
        const conta = listaBancosCaixas.find((item) => item.id == params.value);
        if (!conta) return params.value;
        return conta.nome;
      },
    },
    {
      field: "atrasoDias",
      headerName: "Atraso",
      flex: 350,
      valueGetter: (params) => {
        const dataPagamento = params.row.dataPagamento;
        return getAtrasoDias(contaSelecionada?.dataVencimento, dataPagamento);
      },
    },
    {
      field: "meioPagamentoId",
      headerName: "Meio Pagamento",
      flex: 600,
      valueGetter: (params) => {
        const meioPagamento = listaMeiosPagamento.find(
          (meio) => meio.id == params.value,
        );
        if (!meioPagamento) return params.value;
        return meioPagamento.descricao;
      },
    },
    {
      field: "tipoBaixa",
      headerName: "Tipo de Baixa",
      flex: 600,
      renderCell: (params) => {
        switch (params.value) {
          case "BAIXA_RENEGOCIACAO":
            return "Baixa por Renegociação";
          default:
            return "Baixa Normal";
        }
      },
    },
    {
      field: "valor",
      headerName: "Valor Baixa",
      flex: 450,
      valueGetter: (params) => formatPrice(parseFloat(params.value)),
    },
    {
      field: "insertUserName",
      headerName: "Usuário",
      flex: 450,
    },
  ];

  const atalhosListReceber = [
    {
      keys: ["esc"],
      action: async (e) => {
        e.preventDefault();
        sairBaixaLoteRenegociacao();
        return false;
      },
    },
  ];

  atalhosListReceber.map(({ keys, action }) => Mousetrap.bind(keys, action));

  Mousetrap.stopCallback = function () {
    return false;
  };

  useEffect(() => {
    const filtros = filtrosUrl.get();
    if (renderRenegociacaoTitulos) {
      buscarTitulosParaRenegociacao(filtros);
    } else {
      buscarContasReceber(filtros);
    }
    buscarCondicoesPagamento();
    buscarMeiosPagamento();
  }, [renderRenegociacaoTitulos]);

  useEffect(() => {
    limparSelecao();
  }, [renderBaixaLote, renderRenegociacaoTitulos]);

  async function buscarTitulosParaRenegociacao(filtros) {
    if (renderRenegociacaoTitulos) {
      filtros = {
        ...filtros,
        status: ["ABERTO", "BAIXADO_PARCIAL"],
      };
    }
    await buscarPesquisaAvancada(filtros);
  }

  async function buscarPessoaVendedor(filtros) {
    const filtro = {
      ...filtros,
      nonPaginated: true,
      vendedor: true,
    };
    const dadosUsuario = sessionService.getUsuario();
    const permissaoCaixaColaborador = await permissoesHelper.temPermisao(
      "utilizar-caixa-colaborador",
    );
    const result = await colaboradorService.getAll(filtro);
    if (!result.isAxiosError) {
      const colaboradorVendedorUsuario = result.data.find(
        (colaborador) => colaborador.usuarioId === dadosUsuario.id,
      );
      if (colaboradorVendedorUsuario && permissaoCaixaColaborador) {
        buscarBancosCaixas(colaboradorVendedorUsuario?.bancoCaixaId);
      } else {
        buscarBancosCaixas();
      }
    } else {
      responseErros(result);
    }
  }

  const buscarContasReceber = async (filtro = {}) => {
    setLoading(true);
    const result = await contasReceberService.getAll(filtro);
    if (!result.isAxiosError) {
      setContasReceber(result.data.rows);
      setRowCount(result.data.count);
      setUltimaBusca({ tipo: "simples", filtros: filtro });
      await buscarRelacionamentosContaReceber(result.data.rows);
      buscarPessoaVendedor();
      buscarJurosMulta();
      filtrosUrl.set(filtro);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const buscaUsuarios = async (listaIdUsuario) => {
    if (listaIdUsuario.length) {
      const filtro = {
        nonPaginated: true,
        id: listaIdUsuario,
      };
      return usuarioService.getAll(filtro).then((result) => {
        if (!result.isAxiosError) {
          return result.data;
        } else {
          responseErros(result);
          return [];
        }
      });
    }
  };

  const buscarCondicoesPagamento = () => {
    const filtro = {
      nonPaginated: true,
      ativado: true,
    };
    condicoesPagamentoService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setListaCondicoesPagamento(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarMeiosPagamento = () => {
    const filtro = {
      nonPaginated: true,
      ativado: true,
    };
    meioPagamentoService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setListaMeiosPagamento(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarRelacionamentosContaReceber = async (listaContasReceber) => {
    const idsMeiosPagamento = [];
    const idsPessoas = [];
    for (const objeto of listaContasReceber) {
      if (objeto.pagadorId) idsPessoas.push(objeto.pagadorId);
      idsMeiosPagamento.push(objeto.meioPagamentoId);
    }
    const idsUnicosPessoas = [...new Set(idsPessoas)].filter(
      (item) => item !== null,
    );
    await buscarPessoas({}, idsUnicosPessoas);
  };

  const buscarPessoas = async (filtros, listaIds) => {
    let filtro = { ativado: true, attributes: ["id", "nomeRazaoSocial"] };
    if (listaIds?.length) {
      filtro = {
        ...filtro,
        id: listaIds,
        nonPaginated: true,
      };
    } else {
      filtro = { ...filtro, ...filtros, limite: 15 };
    }
    const result = await pessoaService.getAllFiltroAvancadoSimplificada(filtro);
    if (!result.isAxiosError) {
      const listaPessoas = result.data;
      if (listaIds?.length) {
        setListaPessoas((pessoasAnteriores) =>
          selecaoTitulosLote.unirPorId(pessoasAnteriores, listaPessoas),
        );
      } else setListaPessoasFiltro(listaPessoas?.rows);
    } else {
      responseErros(result);
    }
  };

  const buscarBancosCaixas = async function (id) {
    const filtros = {
      nonPaginated: true,
      ativado: true,
    };
    if (id) filtros.id = id;
    const result = await bancosCaixasService.getAll(filtros);
    if (!result.isAxiosError) {
      setListaBancosCaixas(result.data);
    } else {
      responseErros(result);
    }
  };

  const onClickCadastrarContasReceber = (descricao) => {
    switch (descricao) {
      case "Importação Excel":
        history.push("/financeiro/importacao-contas-receber");
        break;
      case "Carnê de Pagamento":
        setOpenCarnePagamento(true);
        break;
      case "Nota de Crédito":
        setContaReceberDto((prevState) => ({
          ...prevState,
          tipo: "NOTA_CREDITO",
        }));
        history.push("/financeiro/contas-receber/create");
        break;
      case "Boleto":
        history.push("/financeiro/contas-receber/boletos");
        break;
      default:
        history.push("/financeiro/contas-receber/create");
        break;
    }
  };

  const onClickEditContaReceber = (idContaReceber) => {
    history.push(`/financeiro/contas-receber/${idContaReceber}`);
  };

  const deletarContaReceber = async (contaReceberId) => {
    setLoading(true);
    const result = await contasReceberService.deletar(contaReceberId);
    if (!result.isAxiosError) {
      buscarContasReceber();
      notification.deletadoSucesso();
    } else {
      setLoading(false);
      responseErros(result);
    }
  };

  const onClickDeleteContaReceber = async (contaReceberId) => {
    const contaSelecionada = contasReceber.find(
      (item) => item.id === contaReceberId,
    );
    if (contaSelecionada.origem === "RENEGOCIAÇÃO") {
      const confirmado = await confirmarExclusaoRenegociacao(
        contaSelecionada,
        contasReceberService,
      );
      if (confirmado) {
        await deletarContaReceber(contaReceberId);
      }
      return;
    }
    if (contaSelecionada.origem === "MANUAL") {
      const retornoAlerta = await notification.confirmacao(
        "Excluir!",
        "Tem certeza que deseja excluir esta conta a receber?",
      );
      if (retornoAlerta.isConfirmed) {
        if (contaSelecionada.status === "ABERTO") {
          await deletarContaReceber(contaReceberId);
        } else
          notification.alertaGenericos(
            "Só é permitido excluir títulos que se encontram em aberto.",
          );
      }
    } else
      notification.alertaGenericos(
        "Só é permitido excluir títulos que foram inseridos manualmente.",
      );
  };

  const buscarJurosMulta = () => {
    configuracoesService.getJurosMulta().then((result) => {
      if (!result.isAxiosError) {
        setJurosMultaEmpresas(result.data);
      }
    });
  };

  const buscarPesquisaAvancada = async (filter) => {
    setLoading(true);
    const porIntervalo = [];
    const filtrosAvancadosTemp = {
      ...filter,
    };
    if (
      filtrosAvancadosTemp.dataLancamentoStart &&
      filtrosAvancadosTemp.dataLancamentoEnd
    ) {
      porIntervalo.push({
        coluna: "dataLancamento",
        de: filtrosAvancadosTemp.dataLancamentoStart,
        ate: filtrosAvancadosTemp.dataLancamentoEnd,
      });
    }
    if (
      filtrosAvancadosTemp.dataVencimentoStart &&
      filtrosAvancadosTemp.dataVencimentoEnd
    ) {
      porIntervalo.push({
        coluna: "dataVencimento",
        de: filtrosAvancadosTemp.dataVencimentoStart,
        ate: filtrosAvancadosTemp.dataVencimentoEnd,
      });
    }
    if (
      filtrosAvancadosTemp.dataPagamentoStart &&
      filtrosAvancadosTemp.dataPagamentoEnd
    ) {
      porIntervalo.push({
        coluna: "dataPagamento",
        de: filtrosAvancadosTemp.dataPagamentoStart,
        ate: filtrosAvancadosTemp.dataPagamentoEnd,
      });
    }
    delete filtrosAvancadosTemp.dataLancamentoStart;
    delete filtrosAvancadosTemp.dataLancamentoEnd;
    delete filtrosAvancadosTemp.dataNegociacaoStart;
    delete filtrosAvancadosTemp.dataVencimentoStart;
    delete filtrosAvancadosTemp.dataVencimentoEnd;
    delete filtrosAvancadosTemp.dataPagamentoStart;
    delete filtrosAvancadosTemp.dataPagamentoEnd;
    const filtrosBusca = {
      ...filtrosAvancadosTemp,
      restritiva: true,
      porIntervalo,
    };
    const result = await contasReceberService.getAllFiltroAvancado(
      filtrosBusca,
    );
    if (!result.isAxiosError) {
      setContasReceber(result.data.rows);
      setRowCount(result.data.count);
      setUltimaBusca({ tipo: "avancada", filtros: filtrosBusca });
      buscarRelacionamentosContaReceber(result.data.rows);
      delete filtrosAvancadosTemp.status;
      delete filtrosAvancadosTemp.situacaoVencimento;
      filtrosUrl.set(filtrosAvancadosTemp);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const filtrarListaPorPessoa = (value) => {
    if (value) {
      buscarContasReceber({ pagadorId: value.id });
      setBuscaFiltro("");
    } else {
      buscarContasReceber();
      setListaPessoasFiltro([]);
    }
  };

  const sendServerDatagrid = (props) => {
    const { filtros, tipoFiltro } = props;
    if (!filtros) {
      setPessoaFiltro(null);
      setBuscaFiltro("");
    } else if (pessoaFiltro) {
      filtros.pagadorId = pessoaFiltro.id;
    }
    if (renderRenegociacaoTitulos) {
      buscarTitulosParaRenegociacao(filtros);
    } else if (tipoFiltro === "simples") {
      buscarContasReceber(filtros);
    } else {
      buscarPesquisaAvancada(filtros);
    }
  };

  const retornoTopo = () => {
    const ref = document.getElementById("topo-contas-receber");
    setTimeout(
      () =>
        ref?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        }),
      100,
    );
  };

  const selecionarContas = (listaContasReceber) => {
    const totais = calculaTotalAReceber(
      listaContasReceber,
      baixaLote.dataPagamento ?? new Date(),
      jurosMultaEmpresas,
    );
    setTotalAReceber(totais);
    setContasReceberSelecionadas(listaContasReceber);
    setLinhasSelecionadas(listaContasReceber.map((conta) => conta.id));
  };

  const limparSelecao = () => {
    selecionarContas([]);
    setContasFiltroSelecionadas(null);
  };

  const handleSelecaoContas = (newRowSelectionModel) => {
    const listaContasReceber = newRowSelectionModel
      .map(
        (rowId) =>
          contasReceber.find((row) => row.id === rowId) ??
          contasReceberSelecionadas.find((conta) => conta.id === rowId),
      )
      .filter(selecaoTitulosLote.podeSelecionar);
    selecionarContas(listaContasReceber);
  };

  const selecionarTodasContasFiltro = async () => {
    const filtros = selecaoTitulosLote.montaFiltroTitulosAbertos(ultimaBusca);
    if (!filtros) {
      return notification.alertaGenericos(
        "O filtro atual não possui títulos em aberto.",
      );
    }
    setLoading(true);
    const result = await contasReceberService.getAllFiltroAvancado(filtros);
    setLoading(false);
    if (result.isAxiosError) return responseErros(result);
    const { rows, count } = result.data;
    if (!rows.length) {
      return notification.alertaGenericos(
        "O filtro atual não possui títulos em aberto.",
      );
    }
    const listaContasReceber = selecaoTitulosLote.unirPorId(
      contasReceberSelecionadas,
      rows,
    );
    if (
      count > rows.length ||
      listaContasReceber.length > selecaoTitulosLote.limiteTitulos
    ) {
      return notification.alertaGenericos(
        selecaoTitulosLote.mensagemLimite(
          Math.max(count, listaContasReceber.length),
        ),
      );
    }
    buscarRelacionamentosContaReceber(rows);
    selecionarContas(listaContasReceber);
    setContasFiltroSelecionadas({
      chave: selecaoTitulosLote.chaveBusca(ultimaBusca),
      ids: rows.map((conta) => conta.id),
    });
  };

  const desmarcarContasFiltro = () => {
    const idsFiltro = new Set(contasFiltroSelecionadas?.ids);
    selecionarContas(
      contasReceberSelecionadas.filter((conta) => !idsFiltro.has(conta.id)),
    );
    setContasFiltroSelecionadas(null);
  };

  const todasContasFiltroSelecionadas =
    contasFiltroSelecionadas?.chave ===
      selecaoTitulosLote.chaveBusca(ultimaBusca) &&
    selecaoTitulosLote.contemTodas(
      contasFiltroSelecionadas.ids,
      linhasSelecionadas,
    );

  function sairBaixaLoteRenegociacao() {
    setRenderBaixaLote(false);
    setRenderRenegociacaoTitulos(false);
    retornoTopo();
    setBaixaLote({});
  }

  return (
    <>
      <div id="topo-contas-receber"></div>
      <ListLayout
        title="Contas a Receber"
        loading={loading}
        buttonSelectOpcoes={buttonSelectOpcoes}
        onClickCadastrar={onClickCadastrarContasReceber}
        permissaoButton={permissoesHelper.temPermisao(
          "contas-receber-cadastrar",
        )}
        ButtonMenu={
          <ButtonMenu
            renderBaixaLote={renderBaixaLote}
            setRenderBaixaLote={setRenderBaixaLote}
            renderRenegociacaoTitulos={renderRenegociacaoTitulos}
            setRenderRenegociacaoTitulos={setRenderRenegociacaoTitulos}
            openCompensacao={openCompensacao}
            setOpenCompensacao={setOpenCompensacao}
          />
        }
      >
        <div
          style={{
            marginBottom:
              renderBaixaLote || renderRenegociacaoTitulos ? 150 : 0,
          }}
        >
          <DataGrid
            initialState={{
              columns: {
                columnVisibilityModel: {
                  empresaId: usuario.acessosEmpresas?.length > 1,
                },
              },
            }}
            checkboxSelection={renderBaixaLote || renderRenegociacaoTitulos}
            onRowSelectionModelChange={handleSelecaoContas}
            selectionModel={linhasSelecionadas}
            keepNonExistentRowsSelected={
              renderBaixaLote || renderRenegociacaoTitulos
            }
            isRowSelectable={(params) =>
              selecaoTitulosLote.podeSelecionar(params.row)
            }
            extraActions={
              (renderBaixaLote || renderRenegociacaoTitulos) && (
                <SelecaoTitulosFiltro
                  todasSelecionadas={todasContasFiltroSelecionadas}
                  onChangeTodas={(selecionar) =>
                    selecionar
                      ? selecionarTodasContasFiltro()
                      : desmarcarContasFiltro()
                  }
                  quantidadeSelecionada={contasReceberSelecionadas.length}
                  onLimparSelecao={limparSelecao}
                />
              )
            }
            rows={contasReceber}
            columns={colunasListagem}
            rowCount={rowCount}
            onClickEdit={onClickEditContaReceber}
            visualizarShow={permissoesHelper.temPermisao(
              "contas-receber-visualizar",
            )}
            disableAcoes
            paginationMode={"server"}
            sendServer={(props) => sendServerDatagrid(props)}
            FormFiltroAvancado={FormFiltroAvancado}
            disableRowSelectionOnClick
            enableRowDoubleClick
            listaStatus={status}
            ListStatusCustom={ListStatusVencimento}
            FiltroCustom={
              <FiltroCustom
                buscaFiltro={buscaFiltro}
                setBuscaFiltro={setBuscaFiltro}
                listaPessoasFiltro={listaPessoasFiltro}
                setListaPessoasFiltro={setListaPessoasFiltro}
                pessoaFiltro={pessoaFiltro}
                setPessoaFiltro={setPessoaFiltro}
                buscarPessoas={buscarPessoas}
                filtrarListaPorPessoa={filtrarListaPorPessoa}
                sendServer={sendServerDatagrid}
                columns={colunas}
              />
            }
          />
        </div>
      </ListLayout>
      <BaixaLoteReceber
        renderBaixaLote={renderBaixaLote}
        setRenderBaixaLote={setRenderBaixaLote}
        listaContasReceber={contasReceberSelecionadas}
        setListaContasReceber={setContasReceberSelecionadas}
        buscarContasReceber={buscarContasReceber}
        listaMeiosPagamento={listaMeiosPagamento}
        listaBancosCaixas={listaBancosCaixas}
        baixaLote={baixaLote}
        setBaixaLote={setBaixaLote}
        totalAReceber={totalAReceber}
        setTotalAReceber={setTotalAReceber}
        calculaTotalAReceber={calculaTotalAReceber}
        jurosMultaEmpresas={jurosMultaEmpresas}
        retornoTopo={retornoTopo}
      />
      <RenegociacaoTitulos
        renderRenegociacaoTitulos={renderRenegociacaoTitulos}
        setRenderRenegociacaoTitulos={setRenderRenegociacaoTitulos}
        renegociacaoTitulos={renegociacaoTitulos}
        setRenegociacaoTitulos={setRenegociacaoTitulos}
        calculaTotalAReceber={calculaTotalAReceber}
        buscarContasReceber={buscarContasReceber}
        listaCondicoesPagamento={listaCondicoesPagamento}
        listaContasReceber={contasReceberSelecionadas}
        setListaContasReceber={setContasReceberSelecionadas}
        listaPessoas={listaPessoas}
        totalAReceber={totalAReceber}
        retornoTopo={retornoTopo}
        setLoading={setLoading}
        setLinhasSelecionadas={setLinhasSelecionadas}
        setTotalAReceber={setTotalAReceber}
        listaMeiosPagamento={listaMeiosPagamento}
        jurosMultaEmpresas={jurosMultaEmpresas}
      />
      <CompensacaoDialog
        open={openCompensacao}
        setOpen={setOpenCompensacao}
        filtrosDialog={filtrosDialog}
        setFiltrosDialog={setFiltrosDialog}
        buscarContasReceber={buscarContasReceber}
      />
      <CarnePagamentoDialog
        open={openCarnePagamento}
        setOpen={setOpenCarnePagamento}
        colunas={colunas}
      />
      <HistoricoPagamentos
        dadosPagamentoList={contaSelecionada?.pagamentos ?? []}
        dadosPagamentoColunas={dadosPagamentoColunas}
        openHistorico={openHistorico}
        handleHistorico={() => setOpenHistorico(false)}
      />
      <PermissionDialog dialog={dialogPermissao} />
    </>
  );
};

export default ListContasReceber;
